import type { ModelRegistry } from 'ember-data/types/registries/model';
import { type ValidatorResult } from 'ember-changeset-validations';
import {
  validateNumber,
  validatePresence,
} from 'ember-changeset-validations/validators';

const flatAmountValidation = validateNumber({
  gte: 0,
  allowBlank: true,
  integer: true,
});
const percentageAmountValidation = validateNumber({
  gte: 0,
  lte: 100,
  allowBlank: true,
});

export const PropertyFeeValidation = {
  perBookingPercentageTax: [
    validatePresence(true),
    validateNumber({ gte: 0, lte: 100 }),
  ],
  perBookingAmountTax: [
    validatePresence(true),
    validateNumber({ gte: 0, integer: true }),
  ],
  perPersonPerNightTax: [
    validatePresence(true),
    validateNumber({ gte: 0, integer: true }),
  ],
  perNightTax: [
    validatePresence(true),
    validateNumber({ gte: 0, integer: true }),
  ],

  cleaningFee: [
    validatePresence(true),
    validateNumber({ gte: 0, integer: true }),
  ],

  airbnbManagementFeeFlatAmount: flatAmountValidation,
  airbnbManagementFeePercentageAmount: percentageAmountValidation,
  resortFeeFlatAmount: flatAmountValidation,
  resortFeePercentageAmount: percentageAmountValidation,
  communityFeeFlatAmount: flatAmountValidation,
  communityFeePercentageAmount: percentageAmountValidation,
  linenFeeFlatAmount: flatAmountValidation,
  offlineSecurityDepositFlatAmount: flatAmountValidation,
  weeklyDiscount: percentageAmountValidation,
  monthlyDiscount: percentageAmountValidation,

  visitorLevyFlatAmount: validateNumber({ gte: 0, allowBlank: true }),
  visitorLevyPercentageAmount: percentageAmountValidation,
  visitorLevyMaxNights: validateNumber({
    gte: 1,
    allowBlank: true,
    integer: true,
  }),

  petFeeFlatAmount: [
    flatAmountValidation,
    function (
      _key: string,
      newValue: number,
      _oldValue: number,
      _changes: Record<string, unknown>,
      content: ModelRegistry['property-fee'],
    ): ValidatorResult {
      const { lowestRate } = content.property.baseRate;

      // if validation function returns string - it means that validation failed
      return newValue > lowestRate ? 'error' : true;
    },
  ],
};
